import { Pipe, PipeTransform } from '@angular/core';
import { GrundstueckNummerListEntry } from '../../../core/gb-api';
import { TranslateNamePipe } from './translate-name.pipe';

@Pipe({
  name: 'grundstuecknummerExtended'
})
export class GrundstuecknummerPipe implements PipeTransform {
  constructor(private translateName: TranslateNamePipe) {}

  transform(value: GrundstueckNummerListEntry): string {
    if (!value || !value.gbGemeinde) {
      return '';
    }
    let nummer =
      this.translateName.transform(value.gbGemeinde.name) +
      ' ' +
      value.gbGemeinde.bfsNummer +
      this.combineIfNotNull('.', value.gbGemeinde.kreisNummer);
    nummer += '/' + value.nummer;
    nummer += this.combineIfNotNull('-', value.nummerZusatz);
    nummer += this.combineIfNotNull('-', value.nummer3);
    nummer += this.combineIfNotNull('-', value.nummer4);
    return nummer;
  }

  private combineIfNotNull(delimiter: string, nummer: any) {
    if (nummer) {
      return delimiter + nummer.toString();
    }
    return '';
  }
}
